import { Image } from '@chakra-ui/react'
import React from 'react'

function KtLogoComponent() {
    return (
        <Image src="https://ik.imagekit.io/7j3gwo1p1/KelasTambahan_Logo_edited_3u2w6aVDq.png?ik-sdk-version=javascript-1.4.3&updatedAt=1661099961883" />
    )
}

export default KtLogoComponent